import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import QRCode from 'react-qr-code';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';

const QRCodeComponent: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [qrData, setQrData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadQRCode = useCallback(async () => {
    if (!user?.id_pendaftaran) {
      setError('Data user tidak valid');
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const response = await axios.get(`/api/get-qr-code.php?id_pendaftaran=${user.id_pendaftaran}`);
      
      if (response.data.success) {
        setQrData(response.data.data);
      } else {
        setError('Gagal memuat QR Code');
      }
    } catch (error: any) {
      console.error('Error loading QR code:', error);
      setError('Terjadi kesalahan saat memuat QR Code');
    } finally {
      setLoading(false);
    }
  }, [user?.id_pendaftaran]);

  useEffect(() => {
    if (user?.id_pendaftaran) {
      loadQRCode();
    }
  }, [loadQRCode, user?.id_pendaftaran]);

  const handleBack = () => {
    navigate('/dashboard');
  };

  if (!user) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <h1 className="text-xl font-semibold text-gray-900">
                QR Code Peserta
              </h1>
            </div>
            <div className="flex items-center">
              <button
                onClick={handleBack}
                className="ml-4 px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
              >
                Kembali
              </button>
            </div>
          </div>
        </div>
      </nav>

      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <div className="bg-white overflow-hidden shadow rounded-lg">
            <div className="px-4 py-5 sm:p-6">
              {loading ? (
                <div className="text-center">
                  <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600 mx-auto mb-4"></div>
                  <p className="text-gray-600">Memuat QR Code...</p>
                </div>
              ) : error ? (
                <div className="text-center">
                  <div className="text-red-600 mb-4">
                    <p>{error}</p>
                  </div>
                  <button
                    onClick={loadQRCode}
                    className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                  >
                    Coba Lagi
                  </button>
                </div>
              ) : qrData ? (
                <div className="text-center">
                  <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">
                    QR Code untuk {qrData.nama_pendaftar}
                  </h3>
                  
                  <div className="flex justify-center mb-6">
                    <div className="bg-white p-4 rounded-lg shadow-lg">
                      <QRCode
                        value={qrData.kode}
                        size={256}
                        level="H"
                        title={`QR Peserta ${qrData.nama_pendaftar}`}
                      />
                    </div>
                  </div>

                  <div className="text-sm text-gray-600 mb-4">
                    <p>Kode Unik: <span className="font-mono font-semibold">{qrData.kode}</span></p>
                    <p>ID Pendaftaran: <span className="font-semibold">{qrData.id_pendaftaran}</span></p>
                  </div>

                  <p className="text-xs text-gray-500">
                    Tunjukkan QR Code ini saat check-in di acara
                  </p>
                </div>
              ) : (
                <div className="text-center">
                  <p className="text-gray-600">Tidak ada data QR Code</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QRCodeComponent; 